import React from "react";
import { WfDropdown } from "./Controls/Dropdown";
import { Col, Row } from "react-bootstrap";
import { WfControlProps } from "./Controls/ControlProps";
import { WfUnsupport } from "./Controls/Unsupported";
import { WfHeading } from "./Controls/WfHeading";
import { WfText } from "./Controls/Text";
import { WfRadio } from "./Controls/Radio";
import { WfNumber } from "./Controls/Number";
import { Form, Input, InputProps } from "antd";
import { useWfFormRendererContext } from "../../hooks/WfFormRendererContext.hook";
import { Controller } from "react-hook-form";

export type WfControlSwitcherProps = {
  advanceForm: AdvanceForm;
};

export function WfControlSwitcher({
  advanceForm: advanceForm,
}: WfControlSwitcherProps) {
  const { form } = useWfFormRendererContext();
  function Control(props: {
    layout: Layout;
    layouts: Layout[];
    fieldState: any;
    inputProps: InputProps;
  }) {
    const controls: {
      [name: string]: (props: Readonly<WfControlProps>) => JSX.Element;
    } = {
      em: () => <></>,
      l: WfHeading,
      dd: WfDropdown,
      t: WfText,
      r: WfRadio,
      c: WfNumber,
    };
    const control = controls[props.layout.template?.type || "em"] || null;
    return control ? (
      control({ ...props, layoutLength: props.layouts.length })
    ) : (
      <WfUnsupport
        layout={props.layout}
        layoutLength={props.layouts.length}
        fieldState={props.fieldState}
        inputProps={{}}
      />
    );
  }

  return (
    <>
      {advanceForm?.items.map((item, i) => (
        <Row key={i} style={{ paddingTop: "8px", paddingBottom: "8px" }}>
          {item.layout.map((layout, j) => {
            const template = layout?.template;
            const label = template?.label ?? "";
            return layout == null ||
              ["em", "l", null, undefined].includes(template?.type) ? (
              <>
                {Control({
                  layout,
                  layouts: item.layout,
                  fieldState: {},
                  inputProps: {},
                })}
              </>
            ) : (
              <Controller
                key={j}
                control={form?.control}
                name={label}
                rules={{
                  required:
                    template?.attribute?.require == "Y"
                      ? "This field is required"
                      : undefined,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <>
                      {Control({
                        layout,
                        layouts: item.layout,
                        fieldState,
                        inputProps: {
                          ...field,
                          readOnly: template?.attribute?.readonly == "Y",
                          alt: field.value,
                          status: fieldState.invalid ? "error" : undefined,
                        },
                      })}
                    </>
                  );
                }}
              />
            );
          })}
        </Row>
      ))}
    </>
  );
}
